module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_7_neg.bc4e7072.png";